export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-regular-176f8f5bd5f02b3abfcf894955d7e919.woff2";